import React from 'react';
import { FieldControl } from 'spark-core-dx/components';
import { SystemTypes } from 'spark-core-dx/services';
import { useVisualFormContext } from '../../../contexts/VisualFormContext';

const MODEL_KIND_OPTIONS = [
  { Text: 'Table', Value: 1 },
  { Text: 'View', Value: 2 },
];

export const ModelBinding = ({
  modelOptions = [],
  modelKindOptions = MODEL_KIND_OPTIONS,
  inline = false,
  disableModelSelection = false,
  unavailableMessage = 'No models available',
}) => {
  const { visualObject, setVisualModelId, setVisualModelKind } = useVisualFormContext();
  const selectedKind = Number(visualObject?.ModelKind ?? 0);
  const currentModelId = String(visualObject?.ModelId ?? '');
  const availableRelationOptions = selectedKind
    ? modelOptions.filter((option) => Number(option.Kind ?? option.kind) === selectedKind)
    : [];
  const relationOptions = !selectedKind
    ? []
    : availableRelationOptions.length > 0
      ? availableRelationOptions
      : [{
          Text: unavailableMessage,
          Value: '',
          Disabled: true,
        }];
  const relationOptionsKey = relationOptions
    .map((option) => String(option?.Value ?? ''))
    .join('|');

  const modelKindField = (
    <FieldControl
      fieldMetadata={{
        FieldType: SystemTypes.UIFieldType.SelectList,
        FieldName: 'ModelKind',
        DisplayName: 'Model Kind',
        IsRequired: true,
        DataJson: modelKindOptions,
      }}
      groupId={'visual'}
      value={selectedKind || ''}
      onChange={(value) => {
        setVisualModelKind(value);
      }}
    />
  );

  const modelIdField = (
    <FieldControl
      key={`visual-model-id:${selectedKind}:${currentModelId}:${relationOptionsKey}`}
      fieldMetadata={{
        FieldType: SystemTypes.UIFieldType.SearchSelectList,
        FieldName: 'ModelId',
        DisplayName: 'Model',
        IsRequired: true,
        DataJson: relationOptions,
      }}
      groupId={'visual'}
      value={currentModelId}
      disabled={!selectedKind || disableModelSelection}
      onChange={(value) => {
        setVisualModelId(value);
      }}
    />
  );

  if (!inline) {
    return (
      <>
        {modelKindField}
        {modelIdField}
      </>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'nowrap',
        gap: '1rem',
        alignItems: 'flex-start',
        width: '100%',
      }}
    >
      <div style={{ flex: '0 0 10rem', minWidth: 0 }}>
        {modelKindField}
      </div>
      <div style={{ flex: '1 1 auto', minWidth: 0 }}>
        {modelIdField}
      </div>
    </div>
  );
};
